import PointManage from "components/PointManage";

import NotFooterLayout from "layouts/NotFooterLayout";

function PointManagePage() {
  return (
    <>
      <NotFooterLayout namePage="จัดการ Point">
        <div className="layout-content">
          <PointManage />
        </div>
      </NotFooterLayout>
    </>
  );
}

export default PointManagePage;